import { Button, Icon } from '../ds';
import { icons } from '../icons';
import { font } from '../tokens';
import { AbridgeWordmark } from '../components/AbridgeWordmark';
import { beginManualSignIn } from '../api';
import './sign-in.css';

/** The backend owns the OAuth secret and state cookie. Preview supplies a local action. */
export function SignIn({ onSignIn = beginManualSignIn }: { onSignIn?: () => void }) {
  const authError = new URLSearchParams(window.location.search).get('auth_error');
  const authErrorMessage = authError
    ? authError === 'organization_invitation_pending'
      ? 'Your invitation to the Abridge-Commercial GitHub organization is pending. Accept the invitation in your email, then sign in again.'
      : authError === 'organization_membership_required'
      ? 'Your GitHub account is not a member of the Abridge-Commercial organization. Please file a Serval ticket with IT to request an invitation.'
      : 'GitHub sign-in did not complete. Try again, or contact a Vibes admin if the problem continues.'
    : null;

  return <main className="vibes-sign-in" style={{ fontFamily: font }}>
    <div className="signin-atmosphere" aria-hidden="true"><i /><i /><i /></div>
    <div className="signin-grid" aria-hidden="true" />
    <header className="signin-brand"><AbridgeWordmark /></header>
    <section className="signin-card" aria-labelledby="signin-title">
      <div className="signin-eyebrow"><span className="signin-wave" aria-hidden="true"><i /><i /><i /><i /></span>THE INTERNAL APP DEVELOPER PLATFORM</div>
      <h1 id="signin-title">Vibes<span>.</span></h1>
      <p className="signin-description">Turn your ideas into apps. Infrastructure, security, and approval workflows are already baked in.</p>
      <div className="signin-divider" />
      {authErrorMessage && <div role="alert" className="signin-error">{authErrorMessage}</div>}
      <Button variant="primary" leftIcon={icons.signIn} onPress={onSignIn}>Sign in with GitHub</Button>
      <div className="signin-access"><Icon name={icons.info} size="sm" color="#b2d4d1" /><span>For members of the Abridge-Commercial GitHub organization. Need access? File a Serval ticket with IT.</span></div>
    </section>
  </main>;
}
